import React, { useEffect, useState } from 'react';
import { useAuth } from '../features/auth';
import UserLogin from './UserLogin';

// CHANGED: Mobile-first full screen login modal that reuses existing UserLogin component
const MobileLoginModal = () => {
  const { setLoginPromptOpen } = useAuth();
  const [isShortScreen, setIsShortScreen] = useState(false);

  useEffect(() => {
    const mq = typeof window !== 'undefined' ? window.matchMedia('(max-height: 700px)') : null;
    const update = () => setIsShortScreen(Boolean(mq?.matches));
    update();
    mq?.addEventListener?.('change', update);
    return () => mq?.removeEventListener?.('change', update);
  }, []);

  // CHANGED: lock body scroll while mobile modal is open
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const { body } = document;
    if (!body) return undefined;
    const prev = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prev;
    };
  }, []);

  return (
    <div className="mobile-login-modal fixed inset-0 z-[70] flex flex-col bg-white">
      <main className="mobile-login-main flex-1 overflow-hidden p-0 flex h-full flex-col items-stretch">
        <div className="mobile-login-viewport relative w-full h-full min-h-[100dvh] flex">
          <div className="mobile-login-shell flex-1 flex flex-col">
            <div className="mobile-login-close pointer-events-auto absolute right-3 top-3 z-10">
              <button
                type="button"
                onClick={() => setLoginPromptOpen(false)}
                className="mobile-login-close-button rounded-full border border-ponpon-navy/15 bg-white/95 px-3 py-1 text-xs font-semibold text-ponpon-navy/80 shadow-sm"
                aria-label="Close login"
              >
                Close
              </button>
            </div>
            <div className="mobile-login-content flex-1">
              <UserLogin
                initialMode="signup"
                hideHighlights
                hideExplore
                mobileFullHeight
                compact={isShortScreen}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MobileLoginModal;

